import React from 'react';
import ChatSystem from './ChatSystem';

export default function ChatSystemContainer({ variant = 'api', suppressUnreadBadges = false }) {
  return <ChatSystem variant={variant} suppressUnreadBadges={suppressUnreadBadges} />;
}
